var _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowUp = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
  id: "Arrow-Blue-Copy",
  points: "12 9 17 15 7 15"
})));
export { SvgArrowUp as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-up.e639a4e1.svg";